import { userService } from "../services/user.service";
import { accountService } from "../services/account.service";

import { appConstants, months } from "../helpers/constants";
import currency from "../helpers/currencies.json";

export const accountActions = {
    fetchAccounts,
    // searchTransactions,
};


function fetchAccounts(obj) {
  return (dispatch, getState) => {
    dispatch({
      type: appConstants.REQUESTING,
    });
    accountService.getAccountList(obj).then(
      (response) => {
        if(response.data.status == 200){
            
          dispatch({
            type: appConstants.UPDATE_ACCOUNT_LIST,
            accounts: response.data.result,
          });
        }
        else {
          alert(response.data.message);
          dispatch({
            isLoggedIn: false,
            type: appConstants.ERROR_OCCURED,
            error: response.data.message
          });  
        }
        
      },
      (error) => {
        dispatch({
            isLoggedIn: false,
          type: appConstants.ERROR_OCCURED,
          error,
        });
      }
    ).catch(err=>{
      dispatch({
        isLoggedIn: false,
        type: appConstants.ERROR_OCCURED,
        err,
      });
  });
  };
}